<div class="ranking-list-overlay-footer">
  <brt-button [title]="'Schließen'" [color]="'white'" [size]="'large'" (click)="onClosed.emit(true);"></brt-button>
</div>
